import {
  CoreFlightsRebookComponent,
  CORE_FLIGHTS_REBOOK_NAME,
} from "@b2bportal/core-flights-rebook";
import {
  CORE_DISRUPTION_NAME,
  CORE_FINTECH_UI_NAME,
  CORE_FLIGHTS_NAME,
  CORE_TRIPS_NAME,
  CORE_UI_NAME,
  CoreDisruptionComponent,
  CoreFintechUiComponents,
  CoreFlightsComponent,
  CoreTripsComponent,
  CoreUiComponents,
} from "@b2bportal/core-types";
import {
  DeparturePageStyles,
  FlightCardDetailsLoadingStyles,
  FlightCardFareListStyles,
  FareListFareDetailsStyles,
  FlightCardSummaryStyles,
  FlightListGridFilterStyles,
  FlightTimeStyles,
  ReviewPageStyles,
  FlightListNoFlightsStyles,
} from "./flights";
import {
  RebookImportantInfoStyles,
  RebookSummaryPageStyles,
  RebookSegmentSelectionStyles,
  RebookSliceHeader,
  RebookFlightSliceStyles,
  RebookReviewPageStyles,
  RebookFlightSegmentStyles,
} from "./rebooking";
import {
  FintechProductStyles,
  DisruptionOfferSectionStyles,
  HowItWorksDialogStyles,
  IframeDialogStyles,
  FintechProductBulletStyles,
  DisruptionExerciseButtonStyles,
  DisruptionExerciseSelectionStyles,
  FlightDisruptionAlertBannerStyles,
  DisruptionExercisePolicyDetailsStyles,
  DisruptionContactSupportModalStyles,
} from "./styles";
import { TripListPageStyles } from "./trips";
import {
  AlertDialogStyles,
  ButtonStyles,
  DialogStyles,
  PageHeaderStyles,
  PageStyles,
  RadioItemStyles,
  FilterDialogContainerStyles,
  CheckboxStyles,
  CheckboxGroupStyles,
  PopoverStyles,
} from "./ui";

export const styleOverrides = {
  [CoreUiComponents.IframeDialog]: IframeDialogStyles,
  [CORE_TRIPS_NAME]: {
    [CoreTripsComponent.TripListPage]: TripListPageStyles,
  },
  [CORE_FINTECH_UI_NAME]: {
    [CoreFintechUiComponents.FintechProduct]: FintechProductStyles,
    [CoreFintechUiComponents.FintechProductBullet]: FintechProductBulletStyles,
  },
  [CORE_DISRUPTION_NAME]: {
    [CoreDisruptionComponent.DisruptionOfferSection]:
      DisruptionOfferSectionStyles,
    [CoreDisruptionComponent.HowItWorksDialog]: HowItWorksDialogStyles,
    [CoreDisruptionComponent.DisruptionExerciseButton]:
      DisruptionExerciseButtonStyles,
    [CoreDisruptionComponent.DisruptionExerciseSelection]:
      DisruptionExerciseSelectionStyles,
    [CoreDisruptionComponent.FlightDisruptionAlertBanner]:
      FlightDisruptionAlertBannerStyles,
    [CoreDisruptionComponent.DisruptionExercisePolicyDetails]:
      DisruptionExercisePolicyDetailsStyles,
    [CoreDisruptionComponent.DisruptionContactSupport]:
      DisruptionContactSupportModalStyles,
  },
  [CORE_FLIGHTS_NAME]: {
    [CoreFlightsComponent.ReviewPage]: ReviewPageStyles,
    [CoreFlightsComponent.DeparturePage]: DeparturePageStyles,
    [CoreFlightsComponent.FlightListGridFilter]: FlightListGridFilterStyles,
    [CoreFlightsComponent.FlightCardSummary]: FlightCardSummaryStyles,
    [CoreFlightsComponent.FlightTime]: FlightTimeStyles,
    [CoreFlightsComponent.FlightCardDetailsLoading]:
      FlightCardDetailsLoadingStyles,
    [CoreFlightsComponent.FlightCardFareList]: FlightCardFareListStyles,
    [CoreFlightsComponent.FareListFareDetails]: FareListFareDetailsStyles,
    [CoreFlightsComponent.FlightListNoFlights]: FlightListNoFlightsStyles,
  },
  [CORE_FLIGHTS_REBOOK_NAME]: {
    [CoreFlightsRebookComponent.RebookSummaryPage]: RebookSummaryPageStyles,
    [CoreFlightsRebookComponent.RebookImportantInfo]: RebookImportantInfoStyles,
    [CoreFlightsRebookComponent.RebookSegmentSelection]:
      RebookSegmentSelectionStyles,
    [CoreFlightsRebookComponent.RebookSliceHeader]: RebookSliceHeader,
    [CoreFlightsRebookComponent.RebookFlightSlice]: RebookFlightSliceStyles,
    [CoreFlightsRebookComponent.RebookReviewPage]: RebookReviewPageStyles,
    [CoreFlightsRebookComponent.RebookFlightSegment]: RebookFlightSegmentStyles,
  },
  [CORE_UI_NAME]: {
    [CoreUiComponents.Page]: PageStyles,
    [CoreUiComponents.PageHeader]: PageHeaderStyles,
    [CoreUiComponents.AlertDialog]: AlertDialogStyles,
    [CoreUiComponents.Button]: ButtonStyles,
    [CoreUiComponents.Dialog]: DialogStyles,
    [CoreUiComponents.RadioItem]: RadioItemStyles,
    [CoreUiComponents.FilterDialogContainer]: FilterDialogContainerStyles,
    [CoreUiComponents.Checkbox]: CheckboxStyles,
    [CoreUiComponents.CheckboxGroup]: CheckboxGroupStyles,
    [CoreUiComponents.Popover]: PopoverStyles,
  },
};
